import { FormControl, FormGroup, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Switch, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import { Processo } from '../../types/processo/Processo';
import configUrls from '../../config/configUrls';
import TxtTipoProcesso from '../autoComplete/TxtTipoProcesso';
import { TipoProcesso } from '../../types/tipoProcesso/TipoProcesso';
import { useNavigate } from "react-router-dom";



type Props = {
    data: Processo,
    isdisabled?: boolean,
    isLoading?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeSelect?: (e: SelectChangeEvent) => void;
    handleSearchChange: (newValue: TipoProcesso) => void;
}

export function ProcessoForm({
    data,
    isdisabled = false,
    isLoading = false,
    handleSubmit,
    handleChange,
    handleChangeSelect,
    handleSearchChange
}: Props) {

    const navigate = useNavigate();

    return (
        <Box mt={2} p={2}>

            <form onSubmit={handleSubmit} method='POST'>




                <Grid container spacing={3}>


                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TxtTipoProcesso
                                isdisabled={isdisabled}
                                required
                                value={data.tipoProcesso}
                                handleSearchChange={handleSearchChange}
                            />
                        </FormControl>
                    </Grid>


                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Especificação:"
                                name="especificacao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.especificacao} />
                            <FormHelperText>
                                {data.especificacao?.length}/255 caracteres
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                id="observacoes-unidade"
                                required
                                label="Observação desta Unidade:"
                                name="observacao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                multiline
                                rows={4}
                                inputProps={{ maxLength: 255 }}
                                value={data.observacao}
                                placeholder="Digite aqui sua observação..."
                            />
                            <FormHelperText>
                                {data.observacao?.length}/255 caracteres
                            </FormHelperText>
                        </FormControl>
                    </Grid>


                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Nível de Acesso</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.nivelAcesso}
                                label="Nível de Acesso"
                                onChange={handleChangeSelect}
                                disabled={isdisabled}
                                required
                                size='small'
                            >
                                <MenuItem value={'SIGILOSO'}>Sigiloso</MenuItem>
                                <MenuItem value={'RESTRITO'}>Restrito</MenuItem>
                                <MenuItem value={'PUBLICO'}>Público</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>








                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>



                            <Button
                                variant="contained"
                                onClick={() => navigate(-1)}
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </form>



        </Box>
    )
}